import type { DriveStep } from 'driver.js';

export const attorneyInvoicesSteps: DriveStep[] = [
  {
    element: '[data-tour="attorney-invoices-create"]',
    popover: {
      title: 'Create Invoices',
      description: 'Create invoices linked to cases with line items, hours, and rates.',
      side: 'left',
      align: 'center',
    },
  },
  {
    element: '[data-tour="attorney-invoices-summary"]',
    popover: {
      title: 'Financial Summary',
      description: 'Total billed, paid, pending, and overdue across all invoices.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="attorney-invoices-list"]',
    popover: {
      title: 'Manage Invoices',
      description: 'Send to clients, download PDFs, record payments, or delete drafts.',
      side: 'top',
      align: 'center',
    },
  },
];
